import gql from 'graphql-tag'

export const companyUpdate = gql`
  mutation companyUpdate($input: CompanyUpdateInput!) {
    companyUpdate(input: $input) {
      success
    }
  }
`
